import { IntlShape } from 'react-intl';

import messages from './rblTopUpReason.messages';

export const reasons = (intl: IntlShape) => [
    {
        label: intl.formatMessage(messages.stockPurchase),
        value: 'stock_purchase'
    },
    {
        label: intl.formatMessage(messages.bridgingLoan),
        value: 'bridging_loan'
    },
    { label: intl.formatMessage(messages.marketing), value: 'marketing' },
    {
        label: intl.formatMessage(messages.equipmentPurchase),
        value: 'equipment_purchase'
    },
    { label: intl.formatMessage(messages.payBill), value: 'pay_bill' },
    { label: intl.formatMessage(messages.payStaff), value: 'pay_staff' },
    {
        label: intl.formatMessage(messages.refinancingDebt),
        value: 'refinancing_debt'
    },
    { label: intl.formatMessage(messages.other), value: 'other' }
];
